<div class="app-container">
  <app-header></app-header>
  <main role="main">
    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer>
</div>